/**
 * Web Entry Point
 */

import 'react-native-gesture-handler';
import 'react-native-reanimated';
import { AppRegistry } from 'react-native';
import WebApp from './WebApp'; // Web-specific root component
import appConfig from '../app.json';

// Web setup
AppRegistry.registerComponent(appConfig.name, () => WebApp);
AppRegistry.runApplication(appConfig.name, {
  rootTag: document.getElementById('root'),
});

// Hot Module Replacement for development
if (module.hot) {
  module.hot.accept();
}
